import React from 'react'
import Map from '../../Map'
import BookingSubtitle from '../BookingSubtitle/BookingSubtitle'
import { ReactComponent as Call } from '../../../../assets/icon/call.svg'
import { usePartnerContext } from '../../../../context/Common/partner'
import { callPhoneNumberInSkt } from '../../../../utils'
import { useMall } from '../../../../store'
export default function Address() {
	const {
		location_lat: lat,
		location_lng: lng,
		location_address: address,
		mall_phone: phone,
		mall_id: mallId,
	} = useMall(state => state.mall)
	const { partnerName } = usePartnerContext()
	const isHanokWedding = mallId === 'thehanok_wedding'
	const subtitle = isHanokWedding
		? '오시는 길'
		: '주소'

	return (
		<div className="address-container">
			<BookingSubtitle subtitle={subtitle}></BookingSubtitle>
			{typeof kakao === 'undefined' ?
				null :
				<Map lat={lat} lng={lng}></Map>}
			<div className="address-box">
				{isHanokWedding
					? (
						<div className="directions">
							<ul className="direction-list">
								<li>
									<span className="direction-label">전용 셔틀버스 이용</span> (서울 ↔ 영월 왕복)
									<div className="direction-sub"><span className="direction-label">* 탑승지</span>: 용산역 앞 광장 (탑승자 대상 추후 상세 안내)</div>
								</li>
								<li><span className="direction-label">대중교통 이용</span>: 영월역/터미널 하차 후 택시 약 30분 이용</li>
								<li><span className="direction-label">자차 이용</span>: 서울역 기준 약 2시간 30분 소요</li>
							</ul>
						</div>
					)
					: (
						<>
							<div className="street-address">
								<div className="text">{address.road} {address.detail}</div>
							</div>
							<div className="domicile-address">
								<div className="text">지번 : {address.address}</div>
							</div>
						</>
					)}
				<div className="address-phone-container">
					<div className="icon-container">
						<Call className="call-icon" />
					</div>
					<div className="phone b1">
						{partnerName === 'skt'
							? (
								<div className="tel" onClick={() => callPhoneNumberInSkt(phone)}>
									<div className="phone-number">{phone}</div>
								</div>
							)
							: (
								<a href={`tel:${phone}`} className="tel">
									<div className="phone-number">{phone}</div>
								</a>
							)}
					</div>
				</div>
			</div>
		</div>
	)
}
